<ng-container *ngIf="showTenantSwitch()">
<ng-container *ngIf="!layoutService.isCompact(); else compactTenant">
    <div class="tenant-select" *ngIf="activeTenant()">
        <button
            type="button"
            class="tenant-select__trigger"
            [class.is-static]="!switchable()"
            [class.is-open]="menuOpen()"
            (click)="toggleMenu()"
        >
            <span class="tenant-select__label">{{ activeTenant()?.tenantDescription }}</span>
            <i-tabler
                *ngIf="switchable()"
                name="chevron-down"
                class="tenant-select__chevron"
                [class.is-rotated]="menuOpen()"
            />
        </button>

        <div class="tenant-menu tenant-menu--expanded" *ngIf="menuOpen()">
            <ng-container *ngTemplateOutlet="tenantMenuItems"></ng-container>
        </div>
    </div>
</ng-container>
</ng-container>

<ng-template #compactTenant>
    <div class="tenant-badge-wrap">
        <button
            type="button"
            class="tenant-badge"
            [class.is-open]="menuOpen()"
            [class.is-static]="!switchable()"
            [attr.title]="switchable() ? activeTenant()?.tenantDescription : null"
            [attr.aria-label]="switchable() ? 'Mandant wählen — ' + activeTenant()?.tenantDescription : activeTenant()?.tenantDescription"
            [pTooltip]="activeTenant()?.tenantDescription"
            tooltipStyleClass="menu-tooltip-white menu-tooltip-white--btn36"
            tooltipPosition="right"
            [tooltipDisabled]="switchable()"
            (click)="toggleMenu()"
        >
            {{ tenantShort() }}
        </button>

        <div class="tenant-menu tenant-menu--compact" *ngIf="menuOpen()">
            <ng-container *ngTemplateOutlet="tenantMenuItems"></ng-container>
        </div>
    </div>
</ng-template>

<!-- Gemeinsames Mandanten-Menü (DS TenantMenu/TenantItem) — aktiver Eintrag mit orangenem Häkchen -->
<ng-template #tenantMenuItems>
    <button
        type="button"
        class="tenant-menu__item"
        *ngFor="let t of userTenants()"
        [class.is-active]="isActive(t)"
        (click)="selectTenant(t)"
    >
        <span class="tenant-menu__label">{{ t.tenantDescription }}</span>
        <i-tabler *ngIf="isActive(t)" name="check" class="tenant-menu__check" />
    </button>
</ng-template>
